/*jshint -W117 */
(function () {
    'use strict';

    angular
        .module('app.user')
        .component('ubStepWizardOrganization', {
            bindings: {
                existingOrganization: '<',
                model: '<',
                onModelChanged: '&',
                onValidationChanged: '&',
                selectedUserType: '<'
            },
            controller: UserOnboardingStepWizardOrganization,
            controllerAs: 'vm',
            templateUrl: 'app/user/dashboard/onboard/wizard/step-organization/user.onboard.wizard.organization.html'
        });

    /* @ngInject */
    function UserOnboardingStepWizardOrganization(customerService, userOrganizationService, $uibModal) {
        var vm = this;
        vm.$onInit = onInit;

        vm.page = 0;
        vm.pageCount = 10;
        vm.count = 0;

        vm.corporates = [];
        vm.site = null;
        vm.sites = [];

        vm.organization = {
            CustomerId: 0,
            Name: '',
            Address1: '',
            Address2: '',
            City: '',
            StateCode: '',
            ZipCode: '',
            CountryCode: ''
        };

        vm.modalOptions = {
            animation: true,
            templateUrl: 'app/widgets/user-locations/user.locations.modal.html',
            controllerAs: 'vm',
            windowClass: 'md-modal-window'
        };

        vm.addressNotFound = false;
        vm.traffilogAddressNotFound = false;
        vm.selectedCorporate = null;

        vm.searchSites = searchSites;
        vm.onChange = siteChanged;
        vm.siteChanged = siteChanged;
        vm.validate = validate;
        vm.showUserLocations = showUserLocations;
        vm.clearLocations = clearLocations;

        function onInit() {
            console.log('check vm model', vm.model, vm.existingOrganization);
            if (vm.model) {
                vm.model.TraffilogViewCustomerDisplayName = vm.model.TraffilogViewCustomerDisplayName ? vm.model.TraffilogViewCustomerDisplayName :
                    vm.model.CustomerDisplayName;

                geoCodeAddress(vm.model.CustomerDisplayName, callbackSetDataForAddress);

                vm.model.TraffilogZoom = vm.model.Zoom;
                if (vm.model.TraffilogViewCustomerDisplayName) {
                    geoCodeAddress(vm.model.TraffilogViewCustomerDisplayName, callbackSetDataForTraffilogAddress);
                }
            }
        }

        function searchSites(searchValue) {
            if (!searchValue) { return; }

            vm.model = angular.extend(vm.model, {});
            validate();

            return getSites(searchValue, vm.page, vm.pageCount).then(function (result) {
                ATAC.hideLoader();
                return result;
            });

        }

        function getSites(searchTerm, page, pageCount) {
            return customerService.getMatchedCustomers(searchTerm, page, pageCount).then(function (results) {
                if (results.length) {
                    return results.map(function (customer) {
                        return {
                            CustomerId: customer.CustomerID,
                            CustomerDisplayName: customer.CustomerDisplayName,
                            Name: customer.Name,
                            IsDistributor: customer.IsDistributor
                        };
                    });
                }
                return [];
            });
        }

        function geoCodeAddress(address, callback) {
            if (!address) { return; }

            var splitAddress = address.split('-');
            splitAddress = _.rest(splitAddress);
            address = _.reduce(splitAddress, function (prev, next) {
                return prev + ', ' + next;
            });

            return userOrganizationService.geoCodeByAddress(address).then(function (result) {
                callback(result);
            });
        }

        function callbackSetDataForAddress(result) {
            if (result.status === 200 && result.data.items && result.data.items.length > 0) {
                vm.addressNotFound = false;
                vm.model.Center = {};
                vm.model.Center = angular.extend(vm.model.Center, {
                    lat: result.data.items[0].position.lat,
                    lng: result.data.items[0].position.lng
                });
            } else {
                vm.addressNotFound = true;
            }
        }
        
        function callbackSetDataForTraffilogAddress(result) {
            if (result.status === 200 && result.data.items && result.data.items.length > 0) {
                vm.traffilogAddressNotFound = false;
                vm.model.TraffilogCenter = {};
                vm.model.TraffilogCenter = angular.extend(vm.model.TraffilogCenter, {
                    lat: result.data.items[0].position.lat,
                    lng: result.data.items[0].position.lng
                });
            } else {
                vm.traffilogAddressNotFound = true;
            }
        }

        function validate() {
            var validationStatus = false;

            validationStatus = checkValidationOnCustomerSelections();

            vm.onValidationChanged({
                isValid: validationStatus
            });
        }

        function checkValidationOnCustomerSelections() {
            return !!vm.model.CustomerId;
        }

        function siteChanged(site) {
            vm.onModelChanged({ organization: site });

            vm.model = angular.extend(vm.model, site);

            geoCodeAddress(vm.model.CustomerDisplayName, callbackSetDataForAddress);

            validate();
        }

        function traffilogViewCustomerChanged(site) {
            vm.onModelChanged({ organization: site });
            vm.model = angular.extend(vm.model, site);

            geoCodeAddress(vm.model.TraffilogViewCustomerDisplayName, callbackSetDataForTraffilogAddress);
        }

        function showUserLocations(isTraffilog) {
            vm.modalOptions.controller = 'UserLocationsController';
            var modalInstance = $uibModal.open(vm.modalOptions);

            modalInstance.result.then(function (selection) {
                if (isTraffilog) {
                    vm.model.TraffilogViewCustomerId = selection.CustomerID;
                    vm.model.TraffilogViewCustomerDisplayName = selection.CustomerDisplayName;
                    vm.model.TraffilogViewCustomerName = selection.Name;
                    var clone = JSON.parse(JSON.stringify(vm.model));
                    traffilogViewCustomerChanged(clone);
                } else {
                    siteChanged(angular.extend(selection, { CustomerId: selection.CustomerID }));
                    debugger;
                    //IF UserCategoryName == AUTOCAR THEN It is AutoCar user. 
                    if (vm.selectedUserType.UserCategoryName.toUpperCase() == 'AUTOCAR') {
                        // For all autocar users, visibility ID should be fetched through customerID 160136
                        customerService.getCustomer(160136).then(function (response) {
                            if (response != null && response.length > 0) {
                                vm.model.TraffilogViewCustomerId = response[0].CustomerID;
                                vm.model.TraffilogViewCustomerDisplayName = response[0].CustomerDisplayName;
                                vm.model.TraffilogViewCustomerName = response[0].Name;
                                var clone = JSON.parse(JSON.stringify(vm.model));
                                traffilogViewCustomerChanged(clone);
                            }
                        })
                    }
                    // ELES 
                    else {
                        customerService.getCorporateForSitesWithParentCustomer(selection.CustomerID, 6).then(function (response) {
                            if (response != null && response.count > 0 && response[0].ParentCustomer != null) {
                                // IF response.parentcustomer
                                vm.model.TraffilogViewCustomerId = response[0].ParentCustomer.CustomerID;
                                vm.model.TraffilogViewCustomerDisplayName = response[0].ParentCustomer.CustomerDisplayName;
                                vm.model.TraffilogViewCustomerName = response[0].ParentCustomer.Name;
                                var clone = JSON.parse(JSON.stringify(vm.model));
                                traffilogViewCustomerChanged(clone);
                            }
                            else {
                                // ELSE
                                vm.model.TraffilogViewCustomerId = selection.CustomerID;
                                vm.model.TraffilogViewCustomerDisplayName = selection.CustomerDisplayName;
                                vm.model.TraffilogViewCustomerName = selection.Name;
                                var clone = JSON.parse(JSON.stringify(vm.model));
                                traffilogViewCustomerChanged(clone);
                            }
                        })
                    }
                }
            }, function () {
                logger.info('User Location Modal dismissed at: ' + new Date());
            });
        }

        function clearLocations(isTraffilog) {
            if (isTraffilog) {
                vm.model.TraffilogViewCustomerId = null;
                vm.model.TraffilogViewCustomerDisplayName = ' ';
                vm.model.TraffilogViewCustomerName = null;
                geoCodeAddress(vm.model.TraffilogViewCustomerDisplayName, callbackSetDataForTraffilogAddress);
            }
        }
    }
})();
